<div class="display-flex flex-direction-column">
  <h3 class="t-5@r color-void mb-4">You need more Credits</h3>

  <div class="t-8@r color-charcoal mb-1">Your credits balance: {{ memberService.account.token_balance }}</div>

  <div class="t-8@r color-ash mb-6">
    Photos sent to you in a message can be unlocked for just
    {{ memberService.account.costs.unlock_message_photo }} credits.
  </div>

  <button class="mb-4" sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-gold'" (click)="confirm()">
    Buy Credits
  </button>

  <a sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">
    Return to Conversation
  </a>
</div>
